// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"185":"b8d0fd0166e313fabfc3","395":"d800367090b24ce64b6b"}[chunkId] + ".2203.js";
};